module.exports = __webpack_public_path__ + "img/soil_moisture.10d87017.png";